import { colors, isPresetColor, isPresetGradientColor } from '@flex-design-system/fx-colors';

function getColor(color) {
  return isPresetColor(color) ? colors[color] : color;
}
function getBackgroundColorStyle(color) {
  const backgroundProperty = isPresetGradientColor(color) ? "backgroundImage" : "backgroundColor";
  return {
    [backgroundProperty]: getColor(color)
  };
}

export { getBackgroundColorStyle, getColor };
//# sourceMappingURL=colors.mjs.map
